import React from 'react';

import { StyledSwitcherBox, StyledSwitcherLabel, StyledSwitcherInput, StyledText } from './styles';
import { ISwitcherComponent } from './index';

export const Switcher = ({
    theme,
    data,
    translatedData,
    defaultUnit,
    onChange,
    mb,
    dataLocators,
    className,
}: ISwitcherComponent) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e);
    };

    // TODO: maybe we need some fallback in case of wrong value?
    const defaultChecked = (inputValue: string) => inputValue === defaultUnit;

    return (
        <StyledSwitcherBox theme={theme} mb={mb} className={className}>
            {data.map((item: string, index: number) => {
                const checkboxId = `checkbox_${item}`;

                return (
                    <StyledSwitcherLabel key={index} htmlFor={checkboxId} data-locator={`${item}Button`}>
                        <StyledSwitcherInput
                            theme={theme}
                            onChange={handleChange}
                            id={checkboxId}
                            type="radio"
                            name="control"
                            // TODO: with checked we have strange behaviour - every omChange we pass new unit for defaultChecked. Why? Is it mistake? If yes, we just can use defaultChecked
                            checked={defaultChecked(item)}
                            value={item}
                            data-locator={dataLocators?.[index]}
                        />
                        <StyledText theme={theme}>{translatedData[index]}</StyledText>
                    </StyledSwitcherLabel>
                );
            })}
        </StyledSwitcherBox>
    );
};
